import { Box, Typography } from '@mui/material'

import { Maybe, UserDeliveryInfoFragment } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { DeliveryInfoSettingForm } from './DeliveryInfoSettingForm'

export * from './fragments'

export type State = {
  user: Maybe<UserDeliveryInfoFragment>
}

export type Action = {
  onSubmit: (value: {
    phoneNumber: string
    fullName: string
    postalCode: string
    prefecture: string
    city: string
    line1: string
    line2?: Maybe<string>
  }) => Promise<void>
}

export const DeliveryInfoSettingTemplate: Template<State, Action> = ({
  state,
  onSubmit,
}) => {
  const { t } = useTranslation('deliveryInfoSetting')
  const { routerNames, routerPages } = useRouter()
  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
        defaultBackPage: routerPages.AccountSetting,
      }}
    >
      <Head title={routerNames.DeliveryInfoSetting} />
      <Box sx={{ pb: 2 }}>
        <Typography variant="subtitle1" sx={{ pt: 2 }} color="text.secondary">
          {t('label')}
        </Typography>
        <Typography variant="body1" sx={{ pt: 0 }}>
          {state.user?.address?.fullAddress
            ? state.user?.address?.fullAddress
            : t('notRegisteredAddress')}
        </Typography>
      </Box>
      <DeliveryInfoSettingForm
        onSubmitSetting={onSubmit}
        deliveryInfo={state.user || {}}
      />
    </BaseLayout>
  )
}
